import { SelectOption } from '@shape-ds/components';
import { useFilterOptionsQuery } from 'queries/events';
import { useModelsByAssetQuery } from 'queries/notifications/queries';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

export type NotificationFormTypeInput = {
  type: 'select' | 'number';
  name: string;
};

export type NotificationFormTypeOption = {
  name: string;
  enabled: boolean;
  enable_tooltip?: boolean;
  inputs?: NotificationFormTypeInput[];
};

export const NotificationsFormTypeOptions: NotificationFormTypeOption[] = [
  {
    name: 'alarms',
    enabled: true,
    inputs: [
      { type: 'select', name: 'categories' },
      { type: 'select', name: 'models' },
    ],
  },
  {
    name: 'cases',
    enabled: false,
    enable_tooltip: true,
    inputs: [
      { type: 'select', name: 'updates_on' },
      { type: 'select', name: 'disciplines' },
    ],
  },
  {
    name: 'oil_vibration_analysis',
    enabled: false,
  },
  {
    name: 'health_score',
    enabled: false,
    inputs: [{ type: 'number', name: 'low_limit' }],
  },
  {
    name: 'sensor',
    enabled: false,
    enable_tooltip: true,
  },
];

export const useGetNotificationsOptions = (
  notificationTypeName: string,
): { [key: string]: SelectOption[] } => {
  const { watch } = useFormContext();
  const [assets, typeIsEnabled] = watch(['assets', `${notificationTypeName}.selected`]);

  const { data: models = [] } = useModelsByAssetQuery(assets?.[0], {
    enabled: !!assets && assets.length > 0 && notificationTypeName === 'alarms' && typeIsEnabled,
  });

  const { data: categoriesData } = useFilterOptionsQuery({
    enabled: notificationTypeName === 'alarms' && typeIsEnabled,
  });

  return useMemo(
    () => ({
      models,
      categories: categoriesData?.categories || [],
    }),
    [models, categoriesData],
  );
};
